module.exports = __webpack_public_path__ + "img/acesso-readqrcode.269aaf77.png";